module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("UserCreate", "Create new DEFA Link account") ))==null?'':__t)+
'</legend><div><label for="create-email-input">'+
((__t=( i18n.tc("UserCreate", "Email:") ))==null?'':__t)+
'</label> <input type="email" autocomplete="off" id="create-email-input" data-input="create-email" value="'+
((__t=( email ))==null?'':__t)+
'" required></div><div><label for="create-number-input">'+
((__t=( i18n.tc("UserCreate", "Phone number:") ))==null?'':__t)+
'</label> <input type="tel" id="create-number-input" data-input="create-phone-number" value="" required></div><div><label for="create-password-input-1">'+
((__t=( i18n.tc("UserCreate", "Password:") ))==null?'':__t)+
'</label> <input type="password" autocomplete="new-password" id="create-password-input-1" data-input="create-password-1" required></div><div><label for="create-password-input-2">'+
((__t=( i18n.tc("UserCreate", "Repeat password:") ))==null?'':__t)+
'</label> <input type="password" autocomplete="new-password" id="create-password-input-2" data-input="create-password-2" required><p class="hidden static error" data-text="create-password">'+
((__t=( i18n.tc("UserCreate", "The password fields do not match.") ))==null?'':__t)+
'</p></div></fieldset> ';
 if ( context !== "dual" ) { 
__p+=' <div class="input"><small><a href="#" data-click="user-login">'+
((__t=( i18n.tc("UserCreate", "Log in") ))==null?'':__t)+
'</a>| <a href="#" data-click="user-forgot">'+
((__t=( i18n.tc("UserCreate", "Forgot password?") ))==null?'':__t)+
'</a></small></div> ';
 } 
__p+=' <fieldset class="button-wrap"><button class="primary" data-click="create-submit" disabled="disabled">'+
((__t=( i18n.tc("UserCreate", "Create") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
